import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getSavedEvaluationFormData, getSavedEvaluationsData, getSubmittedEvaluationsData, saveEvaluationData, updateSubmittedCommentsDataStart } from '../../actions/Applications/aquaa.action';
import { useHistory } from 'react-router-dom';
import AdminBreadcrumb from '../../components/Administration/General/Admin-breadcrumb';
import Edit_Icon from './../../assets/onboard-images/Edit_Icon.png';
import { AssignedAccountsTblPopUp } from '../../components/TeamLeaderView/AgentsKPIModels/AgentsKPIModels';

const SavedEvaluations = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isEvaluationFetched, setIsEvaluationFetched] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedComment, setSelectedComment] = useState('');
  const [selectedEvaluationId, setSelectedEvaluationId] = useState()

  const savedEvaluationsData = useSelector((state) => state.aquaaReducer.savedEvaluationsData);
  const savedevaluationFormData = useSelector((state) => state.aquaaReducer.savedevaluationFormData);
  const submittedEvaluationsData = useSelector((state)=> state.aquaaReducer.submittedEvaluationsData)
  // Fetch the saved evaluations data on component mount
  useEffect(() => {
    dispatch(getSavedEvaluationsData());
    dispatch(getSubmittedEvaluationsData())
  }, [dispatch]);

  // Get columns based on saved evaluations data
  const columns = savedEvaluationsData && savedEvaluationsData.length > 0 ? Object.keys(savedEvaluationsData[0]) : [];
  const submittedData = submittedEvaluationsData && submittedEvaluationsData.length > 0 ? Object.keys(submittedEvaluationsData[0]) : [];

  const[saveEvaluationID,setSaveEvaluationID] = useState()
  // Handler for clicking on a contact ID
  const contactIdHandler = (row) => {
    if (row.evaluationID && !isEvaluationFetched) {
      dispatch(getSavedEvaluationFormData(row.evaluationID)); // Fetch the evaluation data for this contact
      setIsEvaluationFetched(true); // Mark that the data is being fetched
      setSaveEvaluationID(row.evaluationID)
     
    }
  };

  // useEffect to navigate after the form data is successfully fetched and stored
  useEffect(() => {
    if (
      savedevaluationFormData &&
      Array.isArray(savedevaluationFormData) &&
      savedevaluationFormData.length > 0 && isEvaluationFetched && 
      saveEvaluationID === savedevaluationFormData?.[0]?.AccountDetails?.[0]?.EvaluationID
    ) {
      // Save the evaluation data to the store (if needed)
      dispatch(saveEvaluationData(savedevaluationFormData));

      setIsEvaluationFetched(false)

      history.push('/evaluationform');
    

    }
  }, [savedevaluationFormData,dispatch,history,isEvaluationFetched,saveEvaluationID]);

  const handleEdit = (comment) => {
  setSelectedComment(comment);
  setShowEditModal(true);
};

const submitHandler = () => {
  dispatch(updateSubmittedCommentsDataStart([{"EvaluationID":selectedEvaluationId,"Comments":selectedComment}],() => {
          dispatch(getSubmittedEvaluationsData());
        }));
  setShowEditModal(false)
}
  
console.log('selectedComment',selectedComment,selectedEvaluationId)
  return (
    <section>
    <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/aquaaapplications')} label2='AQuAA' isActive3={false}
            label3='Evaluations' />

       <section className="App_Layout" style={{ marginBottom: '20px' }}>
        <div className="Applications_Title" style={{fontSize:'20px'}}> Submitted Evaluations </div>
      </section>
      <div className="aquaa-table-container">
        <table className="aquaa-table">
          <thead>
            <tr>
              {submittedData.filter(col => col !== 'comments').map((col, index) => (
                <th key={index}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {submittedEvaluationsData && submittedEvaluationsData.length > 0 ? (
              submittedEvaluationsData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {submittedData.filter(col => col !== 'comments').map((col, colIndex) => {
                    const cellData = row[col]; 

                    if (col === 'evaluationDate') {
                      return <td key={colIndex}>{new Date(cellData).toLocaleDateString()}</td>; // Format date
                    }

                    return (
                      <td key={colIndex} style={col === 'evaluationID' ? { cursor: 'pointer', color: '#004aac' } : null}>
                        {col === 'evaluationID' ? <div onClick={() => { contactIdHandler(row) }}>{cellData}</div> : (cellData)}
                      </td>
                    );
                  })}
                  <td>
  <div
    style={{ cursor: "pointer", color: "#004aac" }}
    onClick={() => {setSelectedEvaluationId(row.evaluationID);handleEdit(row.comments)}}
  >
   <img src={Edit_Icon} alt=''/>
  </div>
</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={submittedData.length}>
                  <section>
                    <div className="noData-para" style={{ marginTop: 0 }}>
                      <div style={{ marginTop: 30 }}>
                        No data available, please try different filters or contact the admin.
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showEditModal && (
        <AssignedAccountsTblPopUp isOpen={showEditModal} setShowModal={setShowEditModal}>
        <div className='Applications_Title' style={{fontSize:'20px', marginBottom:20}}>Edit Comments</div>
          <div >
            <textarea 
              type="text"
              placeholder="Comments"
              value={selectedComment}
              onChange={(e) => setSelectedComment(e.target.value)}
              style={{
      width: '100%',
      height: '100px',
      padding: '10px',
      fontSize: '14px',
      resize: 'vertical',
      borderRadius: '5px',
      border: '1px solid #ccc',
      boxSizing: 'border-box'
    }}
            />
          </div>
          <main style={{ display: 'flex', justifyContent: 'center' }}>   <div className='btn_adduser' onClick={() => submitHandler()}>Submit</div>
            <div className='btn_canceluser' onClick={() => setShowEditModal(false)}>Cancel</div></main>
        </AssignedAccountsTblPopUp>
      )}

      <section className="App_Layout" style={{ marginBottom: '20px' }}>
        <div className="Applications_Title" style={{fontSize:'20px'}}> Saved Evaluations </div>
      </section>
      <div className="aquaa-table-container">
        <table className="aquaa-table">
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {savedEvaluationsData && savedEvaluationsData.length > 0 ? (
              savedEvaluationsData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col, colIndex) => {
                    const cellData = row[col]; // Get the data for this column in the current row

                    if (col === 'evaluationDate') {
                      return <td key={colIndex}>{new Date(cellData).toLocaleDateString()}</td>; // Format date
                    }

                    return (
                      <td key={colIndex} style={col === 'evaluationID' ? { cursor: 'pointer', color: '#004aac' } : null}>
                        {col === 'evaluationID' ? <div onClick={() => { contactIdHandler(row) }}>{cellData}</div> : (cellData)}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length}>
                  <section>
                    <div className="noData-para" style={{ marginTop: 0 }}>
                      <div style={{ marginTop: 30 }}>
                        No data available, please try different filters or contact the admin.
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default SavedEvaluations;
